import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

class CustomersController {
  static $inject = ['$scope'];

  constructor(private $scope: IScope & { customers: TODO }) {}
}

export const CustomersControllerModule = angular
  .module('acme.view.application.customers.controllers', [])
  .controller('CustomersController', CustomersController).name;
